import he from 'he';
import fp from 'lodash/fp';
import React from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { branch, compose, lifecycle, renderComponent, withProps } from 'recompose';
import { bindActionCreators } from 'redux';
import { routes } from '../../../../constants';
import { businessActions, businessSelector, currentTeamMembersSelector, teamMembersSelector } from '../../../../state/modules/business';
import { industryActions } from '../../../../state/modules/industry';
import { industriesSelector } from '../../../../state/modules/industry/selectors';
import { currentUserIndustryId, currentUserSelector, userAfslSelector } from '../../../../state/modules/user';
import { possessiveCase } from '../../../../utils';
import { Icon } from '../../../components';
import Loading from '../../loading';
import { PersonalDetails, PopulatedCpdActivity, StaticAfslSetting } from '../professional-profile/partials';
import Qualifications from '../professional-profile/qualifications/qualifications';
import TrainingPlanHistory from '../professional-profile/training-plan-history';

const TeamUserProfessionalProfile = ({
  user,
  userIndustry,
  business,
  contextBusinessTeamId,
  personalDetailsProps: {
    businesses
  },
  populatedCpdActivityProps: {
    cpdActivity
  },
  populatedCpdActivityDispatch: {
    getCpdPoints
  },
  AfslSettingProps: {
    afsLicence
  },
  contextUserId,
  fullName,
  profile
}) => (
    <div className='base-layout'>
      <section id='header--profile' key='profile-header' className='layout--header'>
        <Grid>
          <Row className='button-gutter'>
            <Col xs={12} md={12}>
              <h1><Icon icon='professional-profile-large' />{possessiveCase(he.decode(fullName))} Professional Profile</h1>
              <hr />
            </Col>
          </Row>
        </Grid>
      </section>
      <div id='section--professional-profile' key='profile-section' className='layout--section'>
        <Grid>
          <PersonalDetails
            enableUpdate={false}
            businesses={businesses}
            user={user}
            isFullWidth={userIndustry && userIndustry.name !== 'Financial Advice'} />
          {
            userIndustry && userIndustry.name === 'Financial Advice' ?
              <StaticAfslSetting
                afsLicence={afsLicence}
                user={user} /> :
              null
          }
          <Qualifications businessId={business.id} userId={contextUserId} />
          <PopulatedCpdActivity
            detailPageRoute={contextBusinessTeamId ? routes.app.teams.teamMemberCpdActivity(contextBusinessTeamId, contextUserId) : routes.app.teams.userCpdActivity(contextUserId)}
            cpdActivity={cpdActivity}
            getCpdPoints={getCpdPoints(business.id, user.id)}
            user={user} />
          <TrainingPlanHistory forBusinessUser={true} profile={profile} />
        </Grid>
      </div>
    </div>
  );

const mapStateToProps = (state) => ({
  currentUser: currentUserSelector(state),
  userIndustryId: currentUserIndustryId(state),
  industries: industriesSelector(state),
  isFetchingIndustries: state.industry.isFetching,
  allTeamMembers: teamMembersSelector(state),
  currentTeamMembers: currentTeamMembersSelector(state),
  business: businessSelector(state),
  personalDetailsProps: {
    businesses: fp.map(({ business }) => business.name)(state.business.businesses)
  },
  AfslSettingProps: {
    afsLicence: userAfslSelector(state)
  },
  populatedCpdActivityProps: {
    cpdActivity: state.business.cpdActivities ? state.business.cpdActivities.userCpdPoints : [],
  },
  profile: state.business.user.profile
})

const mapDispatchToProps = (dispatch) => ({
  getTeam: bindActionCreators(businessActions.business.team.getTeam, dispatch),
  getQualifications: bindActionCreators(businessActions.business.user.getQualifications, dispatch),
  getProfile: bindActionCreators(businessActions.business.user.getProfile, dispatch),
  getIndustries: bindActionCreators(industryActions.industries.get, dispatch),
  populatedCpdActivityDispatch: {
    getCpdPoints: (businessId, userId) => (filter) => bindActionCreators(businessActions.business.user.getCpdActivities, dispatch)(businessId, userId, filter),
  }
})

export default compose(
  withProps(({
    match: {
      params: {
        team,
        user
      }
    }
  }) => ({
    contextBusinessTeamId: team,
    contextUserId: user
  })),
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      const {
        business,
        contextBusinessTeamId,
        contextUserId,
        getTeam,
        getIndustries,
        getQualifications,
        getProfile
      } = this.props;

      if (contextBusinessTeamId) {
        getTeam(business.id, contextBusinessTeamId);
      }

      if (business && contextUserId) {
        getQualifications(business.id, contextUserId);
        getProfile(business.id, contextUserId);
      }

      getIndustries();
    }
  }),
  withProps(({
    profile
  }) => {
    return ({
      user: fp.get('user')(profile)
    })
  }),
  branch(
    ({ user, isFetchingIndustries }) => isFetchingIndustries || !user,
    renderComponent(Loading)
  ),
  withProps(({
    user: {
      firstName,
      lastName
    },
    industries,
    userIndustryId }) => ({
      fullName: `${firstName} ${lastName}`,
      userIndustry: fp.find(industry => industry.id === userIndustryId)(industries)
    })),
)(TeamUserProfessionalProfile);



// WEBPACK FOOTER //
// ./src/containers/pages/app/teams/user-professional-profile.js